import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { SectionTitle } from 'components/_basic/SectionTitle/SectionTitle';

import { UserAccountSettings } from './components/UserAccountSettings';

export const AccountSettingsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <script type="text/javascript" defer>
          {`
                  window.dataLayer = window.dataLayer || [];
                  let userId = '';
                  try {
                    const userStore = localStorage.getItem('user-store');
                    if (userStore) {
                      const parsed = JSON.parse(userStore);
                      userId = parsed?.state?.authUser?.id || '';
                      dataLayer.push({ user_id: userId });
                    }
                  } catch (e) {
                    console.error('Failed to parse user-store:', e);
                  }
                `}
        </script>
      </Helmet>
      <SectionTitle title={t('accountSettings')} />
      <UserAccountSettings />
    </>
  );
};
